export const tickerNotices = [
  "地址会不定期更换，建议把本页加入收藏，随时查看最新地址与解决办法。",
  "官方网站地址 2025 的变动以站内公告为准，请勿在来源不明的页面输入账号或支付信息。",
  "打不开时先别急，按页面中的自检步骤逐条排查，多数情况可以恢复访问。",
];

export const navItems = [
  { id: "updates", label: "最新地址动态" },
  { id: "reasons", label: "打不开原因" },
  { id: "solutions", label: "解决办法" },
  { id: "domain", label: "新域名辨别" },
  { id: "entry", label: "永久入口" },
  { id: "where", label: "去哪里看" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { icon: "ri-refresh-line", label: "地址更新", value: "不定期", note: "以官方公告为准" },
  { icon: "ri-bookmark-3-line", label: "推荐做法", value: "收藏本页", note: "防止地址走丢" },
  { icon: "ri-shield-check-line", label: "访问安全", value: "核对来源", note: "不输入敏感信息" },
];

export const updateTags = ["全部", "地址更新", "公告提醒", "使用技巧"];

export const updateLogs = [
  {
    id: 1,
    date: "2025-10-05",
    tag: "地址更新",
    title: "进入新一轮地址更换周期",
    desc: "旧的访问地址可能陆续失效，请尽快把本页加入收藏作为固定入口，避免真正需要时一时找不到最新地址。",
  },
  {
    id: 2,
    date: "2025-09-28",
    tag: "公告提醒",
    title: "警惕来源不明的链接",
    desc: "请勿在陌生来源的页面输入账号、密码或支付信息。官方渠道不会通过私信、弹窗等方式索要这类信息。",
  },
  {
    id: 3,
    date: "2025-09-21",
    tag: "使用技巧",
    title: "建议同时保留多个入口",
    desc: "把常用入口分别收藏到浏览器书签与云笔记，任意一个入口失效时，仍能通过其他入口快速回到最新地址。",
  },
  {
    id: 4,
    date: "2025-09-15",
    tag: "地址更新",
    title: "部分旧地址已停止使用",
    desc: "如果出现无法访问、跳转空白或长时间加载，通常说明该地址已经过期，按页面中的解决办法重新获取即可。",
  },
  {
    id: 5,
    date: "2025-09-08",
    tag: "公告提醒",
    title: "浏览器缓存可能导致打不开",
    desc: "更换地址后，旧的缓存有时仍指向失效页面，清除缓存或改用无痕模式，往往能恢复正常访问。",
  },
  {
    id: 6,
    date: "2025-08-30",
    tag: "使用技巧",
    title: "判断自己是否用对了入口",
    desc: "正确的入口一般能稳定打开并显示完整页面。若页面频繁跳转、弹窗过多，请谨慎操作并重新核对来源。",
  },
  {
    id: 7,
    date: "2025-08-22",
    tag: "地址更新",
    title: "移动网络与宽带的表现可能不同",
    desc: "同一地址在不同网络下结果可能不一样。若手机可以打开而宽带不行，可先切换网络环境再尝试。",
  },
  {
    id: 8,
    date: "2025-08-14",
    tag: "公告提醒",
    title: "本页持续同步最新动态",
    desc: "本页会跟随地址与公告的变化更新内容，建议把它作为常用页面保存，方便随时查看最新地址与解决办法。",
  },
];

export const reasons = [
  {
    icon: "ri-link",
    title: "访问地址发生更换",
    desc: "站点会不定期更换访问地址，旧的地址在更换后可能被停用，于是原本能打开的页面会突然失效。",
  },
  {
    icon: "ri-wifi-line",
    title: "本地网络或解析异常",
    desc: "本地网络、运营商线路或域名解析出现波动时，即使地址本身正确，也可能出现加载缓慢或打不开的情况。",
  },
  {
    icon: "ri-history-line",
    title: "浏览器缓存与 Cookie 过期",
    desc: "残留的缓存仍指向旧地址，容易出现页面空白、报错或反复跳转，更换地址后这种情况尤其常见。",
  },
  {
    icon: "ri-shield-line",
    title: "插件或安全软件拦截",
    desc: "广告拦截、脚本拦截类插件以及部分安全软件，可能误拦页面所需的资源，造成内容加载不完整。",
  },
  {
    icon: "ri-global-line",
    title: "不同网络环境表现不同",
    desc: "同一地址在不同地区、不同运营商下的结果可能不一样，某个网络受限并不代表地址本身有问题。",
  },
  {
    icon: "ri-error-warning-line",
    title: "收藏或转发了过期网址",
    desc: "旧网址一旦失效，继续从旧链接进入自然无法打开。此时需要重新确认当前使用的最新地址。",
  },
];

export const steps = [
  {
    order: 1,
    title: "先核对是不是最新地址",
    desc: "确认当前使用的地址是否为本页展示的最新地址，旧地址、二手转发的链接都不建议继续使用。",
    tip: "把本页与手头的地址对照一遍，是最快的排查起点。",
  },
  {
    order: 2,
    title: "清除浏览器缓存与 Cookie",
    desc: "清掉与旧地址相关的缓存后重新打开页面，可排除旧缓存指向失效地址造成的空白或报错。",
    tip: "手机浏览器同样可以在设置中清理浏览数据。",
  },
  {
    order: 3,
    title: "改用无痕模式或其他浏览器",
    desc: "无痕窗口不受历史缓存影响，若在无痕下能打开，基本可以判断问题出在缓存或插件上。",
    tip: "换一个浏览器再试一次，能快速区分是浏览器问题还是网络问题。",
  },
  {
    order: 4,
    title: "检查网络与 DNS 设置",
    desc: "可尝试重启路由器、切换 Wi-Fi 与移动数据，或把 DNS 改为公共 DNS，排除解析异常。",
    tip: "同一网络下其他网站正常，才说明问题更可能出在目标地址本身。",
  },
  {
    order: 5,
    title: "暂时关闭拦截插件与安全软件",
    desc: "关闭广告拦截、脚本拦截插件或安全软件的网页防护后再刷新，确认是否被误拦。",
    tip: "排查完成后记得重新开启，日常防护仍然需要保留。",
  },
  {
    order: 6,
    title: "切换网络环境再试",
    desc: "从 Wi-Fi 切到移动数据，或从移动数据切回 Wi-Fi，往往能绕开某个网络的临时限制。",
    tip: "不同运营商的表现可能不同，多试一条线路更稳妥。",
  },
  {
    order: 7,
    title: "回到本页查看最新动态",
    desc: "如果以上方法都无效，多半是地址已经更换，回到本页查看最新地址动态即可获取当前入口。",
    tip: "这也是为什么建议长期收藏本页，作为固定入口。",
  },
];

export const domainTips = [
  {
    title: "以官方公告为准",
    desc: "地址是否更换以站内公告为准，不要仅凭他人转发的截图或短链接下结论。",
  },
  {
    title: "核对域名是否完整",
    desc: "留意域名是否被多加字符、替换相近字母，这类仿冒地址在视觉上很容易被忽略。",
  },
  {
    title: "留意异常跳转",
    desc: "打开后若不断跳到陌生页面，或强制要求下载不明程序，应立即停止操作并退出。",
  },
  {
    title: "不在可疑页面输入信息",
    desc: "任何索要账号、密码、验证码或支付信息的页面，都应先确认来源再决定是否继续。",
  },
  {
    title: "收到陌生链接先观望",
    desc: "对来路不明的群发链接保持谨慎，优先通过本页等固定入口进入，而不是直接点开链接。",
  },
];

export const permanentWays = [
  {
    icon: "ri-bookmark-3-line",
    title: "把本页加入收藏",
    desc: "本页持续同步最新地址与公告，收藏后无论地址怎么变，都能从这里重新找到入口。",
  },
  {
    icon: "ri-file-copy-2-line",
    title: "多处备份入口",
    desc: "把入口同时记在浏览器书签、云笔记和手机备忘录里，避免单一设备出问题就彻底找不到。",
  },
  {
    icon: "ri-notification-3-line",
    title: "订阅更新提醒",
    desc: "通过邮箱或消息方式订阅更新，地址一旦有变化就能第一时间收到提示，不用反复手动查找。",
  },
  {
    icon: "ri-cloud-line",
    title: "使用可同步的书签",
    desc: "登录账号的书签可在手机与电脑之间同步，换设备后依然能直接打开保存好的入口。",
  },
];

export const entryChannels = [
  {
    icon: "ri-list-check-2",
    title: "本页更新记录",
    desc: "页面中的「最新地址动态」会持续记录地址更换与公告提醒，是最直接的查看位置。",
    tag: "推荐",
  },
  {
    icon: "ri-bookmark-line",
    title: "浏览器书签",
    desc: "把本页或官方入口加入书签栏，地址变化时从书签进入即可，不必重新搜索。",
    tag: "常用",
  },
  {
    icon: "ri-sticky-note-line",
    title: "云笔记与备忘录",
    desc: "在云笔记中记录多个入口与更新日期，换设备或重装系统后依然可以找回。",
    tag: "备份",
  },
  {
    icon: "ri-mail-line",
    title: "邮箱或消息订阅",
    desc: "订阅更新通知后，地址有变动会主动提醒，适合不常手动检查的用户。",
    tag: "提醒",
  },
  {
    icon: "ri-group-line",
    title: "社群与好友互告",
    desc: "在可信的社群里与其他用户互相提醒，遇到打不开时可以快速确认是否为地址更换。",
    tag: "互助",
  },
  {
    icon: "ri-megaphone-line",
    title: "站内公告栏",
    desc: "进入页面后优先查看公告栏，最新地址与重要提醒通常都会在此同步发布。",
    tag: "官方",
  },
];

export const glossary = [
  {
    term: "最新地址",
    desc: "指当前可以正常访问的入口地址。由于地址会不定期更换，最新地址会随时间变化，需以官方公告为准。",
  },
  {
    term: "官网地址 2025",
    desc: "指 2025 年阶段对外公布的官方访问地址。它是一个时间范围的说法，具体以页面展示的当前地址为准。",
  },
  {
    term: "新域名",
    desc: "地址更换后启用新的域名，旧域名可能被停用。判断新域名时，应优先参考官方公告而不是转发链接。",
  },
  {
    term: "永久入口",
    desc: "一个固定不变、可长期保存的页面地址。把它收藏起来，即使访问地址变化，也能回到这里重新获取。",
  },
  {
    term: "防走丢",
    desc: "指通过收藏固定入口、多处备份、订阅提醒等方式，确保地址变化时依然能快速找回最新地址。",
  },
];

export const faqs = [
  {
    q: "韩剧TV 官网地址 2025 指的是什么？",
    a: "它是 2025 年阶段对外公布的官方访问地址的说法。因为地址会不定期更换，所以并不存在一个始终不变的具体网址。更稳妥的做法是把本页作为固定入口收藏起来，需要时从这里查看当前地址。",
  },
  {
    q: "韩剧TV 新域名是多少？",
    a: "新域名会随着地址更换而变化，且应以官方公告为准。与其记住某个具体域名，不如记住获取域名的固定入口。本页的「最新地址动态」会同步相关变化，避免记错或轻信转发而来的链接。",
  },
  {
    q: "打不开就说明被封了吗？",
    a: "不一定。打不开的原因有很多，例如地址已更换、本地缓存指向旧地址、插件误拦或网络解析异常等。建议先按页面中的自检步骤逐条排查，多数情况可以自行解决，而不是直接判断为被封。",
  },
  {
    q: "换了网址之后去哪里看？",
    a: "优先查看本页的「最新地址动态」，那里会记录地址更换与公告提醒。此外还可以通过浏览器书签、云笔记备份、邮箱订阅通知以及可信社群互相提醒等方式获取，具体可参考页面中的「换网址了去哪里看」。",
  },
  {
    q: "永久入口真的永久吗？",
    a: "所谓永久入口，指的是一个长期保存、相对固定的页面地址，用于在访问地址变化后重新找到最新地址。它本身也需要你主动收藏并定期回访，才能发挥作用。建议至少在两三个地方做好备份。",
  },
  {
    q: "访问时需要注意哪些安全问题？",
    a: "不要在来源不明的页面输入账号、密码、验证码或支付信息；遇到频繁跳转、强制下载的行为要立刻退出；对陌生人发来的链接保持谨慎，优先通过固定入口进入，而不是直接点开转发链接。",
  },
  {
    q: "手机能打开、电脑却打不开怎么办？",
    a: "这说明地址本身很可能是正常的，问题更可能出在电脑端的网络或缓存上。可以先清理浏览器缓存、关闭拦截插件，再把 DNS 改为公共 DNS，或切换网络环境后重新尝试。",
  },
];